module.exports = __webpack_public_path__ + "img/bg.79a2f0a8.jpg";